import { render, staticRenderFns } from "./SecondTab.vue?vue&type=template&id=16a25436&scoped=true&"
import script from "./SecondTab.vue?vue&type=script&lang=js&"
export * from "./SecondTab.vue?vue&type=script&lang=js&"
import style0 from "./SecondTab.vue?vue&type=style&index=0&id=16a25436&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16a25436",
  null
  
)

export default component.exports